import { Component, Vue, Prop } from 'vue-property-decorator';
import { SettingModel } from '@/models/setting';

@Component({})
export default class SettingBase extends Vue {
  @Prop({ required: true }) public setting!: SettingModel;
}
